

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { TeamUser } from '@/models/admin/team';
import { UserModel } from '@/models/admin/users';
import { Base } from '@/components/common/base';
import {teamService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
})
export default class UserSavePage extends Base {
    public teamUser: TeamUser = {
        userId: '',
        userEmail: '',
    };
    public form: any = {};
    public formFields: Array<VFields<any>> = [];
    public storeId: number = 0;
    public users: UserModel[];
    public teamId: string = '';
    public disableSubmitButton: boolean = false;

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'backToList') {
            this.$router.push({ name: 'admin.teams.users', params: { teamId: this.teamId, storeId: this.storeId.toString() } });
        } else if (methodName === 'submit') {
            if (!this.form.$valid) {
                this.showAlert(false, 'Form is Invalid!');
                this.resetMethodName(methodName);
                return;
            }

            this.submitTeamUser();
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$parent.$t('teams.btnBack'), disabled: false, visible: true, class: 'btn', label: this.$parent.$t('teams.btnBack'), click: 'backToList', icon: 'fas fa-arrow-left' });
        this.$emit('updateToolBar', buttons);
    }
    public async mounted(): Promise<void> {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'teams');

        this.storeId = Number(this.$route.params.storeId);
        this.teamId = this.$route.params.teamId;
        this.setFields();

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        await this.getAllUsers();
    }

    public setFields(): void {
        this.formFields = [
            {
                key: 'userId',
                type: 'v-alynk-select',
                required: true,
                templateOptions: {
                    counter: 500,
                    label: this.$t('teams.teamUserFields.userEmail') as string,
                    items: this.users,
                    text: 'email',
                    value: 'id',
                    required: true,
                    disabled: false,
                    altag: 'User Email',
                    loading: false,
                    rules:[
                        v => this.required('User Email',v),
                    ]
                },
            },
        ];
    }

    public validateTeamUser(): Vue & { validate: () => boolean } {
        return this.$refs.teamUserForm as Vue & { validate: () => boolean };
    }

    public async submitTeamUser(): Promise<void> {
        if(this.validateTeamUser().validate()){
            try {
                this.disableSubmitButton = true;
                this.$emit('update:progress', this.disableSubmitButton);
                const userDetails = this.users.filter((user) => {
                    return user.id === this.teamUser.userId;
                });
                if (userDetails.length > 0) {
                    this.teamUser.userEmail = userDetails[0].email;
                }
                await teamService.saveUser(this.teamId, this.teamUser, this.storeId);
                this.showAlert(true, this.$t('teams.alertSaveTeamUser'));
                this.$router.push({
                    name: 'admin.teams.users',
                    params: { teamId: this.teamId, storeId: this.storeId.toString() },
                });
            } finally {
                this.disableSubmitButton = false;
                this.$emit('update:progress', this.disableSubmitButton);
            }
        }
    }

    public async getAllUsers(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.formFields);
            const response = await teamService.getUsers(this.teamId, this.storeId);
            this.users = response.results;
            this.setFields();
        } finally {
            this.formlyHideSkeleton(this.formFields);
        }
    }
}
